import React from 'react';
import { bibleFaqs } from '../data/bibleFaqs';
export function BibleFaq() {
  return <div data-id="element-16" data-mp="3614dyb7xxmj0">
      {bibleFaqs.map(faq => <details key={faq.id} className="bible-details border-b border-[#2c2a30] py-[22px]" data-id="element-17" data-mp="362fgk7pngo8j">
          <summary className="flex cursor-pointer justify-between gap-5 font-semibold" data-id="element-18" data-mp="3kywun6p84gys">
            {faq.question}
          </summary>
          <p className="mr-0 mt-4 text-[15px] leading-[1.7] text-[#beb9b0] md:mr-8" data-id="element-19" data-mp="3g1eqruq2crxn">
            {faq.answer}
          </p>
        </details>)}
    </div>;
}